import FeatureVideo from '@rsa-digital/evo-shared-components/components/Video/FeatureVideo';
import { graphql } from 'gatsby';
import React from 'react';
import { processOptionalCta } from 'helpers/csTypeProcessors';
import { getVideoCookiePolicyData } from 'helpers/videos';
import { CsCta } from 'types/contentStack';

type FeatureVideoBlockProps = {
  feature_video: {
    html_id?: string;
    src: string;
    screen_reader_text: string;
    heading: string | null;
    subheading: string | null;
    body: string | null;
    cta: [CsCta] | null;
  };
};

export const query = graphql`
  fragment FeatureVideoBlock on cs__feature_video {
    html_id
    src
    screen_reader_text
    heading
    subheading
    body
    cta {
      ...Cta
    }
  }
`;

//
// See documentation about Optanon Cookie Categories in src\helpers\videos.ts
//
const FeatureVideoBlock: React.FC<FeatureVideoBlockProps> = ({ feature_video }) => (
  <FeatureVideo
    data-cy="FeatureVideo"
    id={feature_video.html_id}
    src={feature_video.src}
    screenReaderText={feature_video.screen_reader_text}
    heading={feature_video.heading ?? undefined}
    subheading={feature_video.subheading ?? undefined}
    body={feature_video.body ?? undefined}
    forceHeadingsOnTop
    cta={processOptionalCta(feature_video.cta, 'featureVideoCta')}
    videoCookiePolicyData={getVideoCookiePolicyData(feature_video.src)}
  />
);

export default React.memo(FeatureVideoBlock);
